import { makeActionCreator } from '../../core/types/redux';
import {
  SidePanelActionConstants as C,
} from './types';

const create = makeActionCreator<C>();

export const extendMenu = create(C.MENU_EXTEND);
export const collapseMenu = create(C.MENU_COLLAPSE);
